import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AccountsDropdown from './AccountsDropdownComponent';
import { selectAccount } from '@t7x000/apex-web/lib/redux/actions/userActions';
import { defaultAccountSelector, accountsSelector } from '@t7x000/apex-web/lib/redux/margin/selectors';
import { RETIREMENT_ACCOUNT_SUFFIX } from '../../constants';

const mapStateToProps = (state) => {
  const { selectedAccountId } = state.user;
  const accounts = accountsSelector(state);
  let selectedAccount = accounts.find((account) => account.AccountId === selectedAccountId);

  if (!selectedAccount) {
    selectedAccount = defaultAccountSelector(state);
  }

  const tradingAccountId = defaultAccountSelector(state)?.AccountId;
  const retirementAccountId = accounts.find((account) =>
    account.AccountName.endsWith(RETIREMENT_ACCOUNT_SUFFIX),
  )?.AccountId;

  return {
    accounts,
    selectedAccount,
    tradingAccountId,
    retirementAccountId,
  };
};

const mapDispatchToProps = {
  selectAccount,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountsDropdown));
